export const RequestContactByPocId = `
    query requestContactByPocId ($pocid: BigInt!) {
        contactByPocid (pocid: $pocid) {
            pocid
            name
            cell
            land
            email
            pubconinfo
            instruc
            datelastchanged
            document
        }
    }
`
